/** @format */

export const initialState = {
  info: {},
  refetchTaskCount: () => {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'setInfo':
      return { ...state, info: action.payload };
    case 'setRefetchTaskCount':
      return { ...state, refetchTaskCount: action.payload };
    default:
      return state;
  }
};
